// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Loader_skeleton__12SZH","content":"Loader_content__2glDk","title":"Loader_title__1U-ho","rest":"Loader_rest__3t9q_"};